import { COLORS, DEVICES, FONT_FAMILY } from '@Commons';
import styled from 'styled-components';

export const MobileBox = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
`;

export const MobileCode = styled.div`
  flex: 0 0 90px;
  min-width: 90px;
`;

export const MobileNumber = styled.div`
  flex: 1;
  .MuiFormControl-root {
    max-width: 100%;
    width: 336px;

    @media ${DEVICES.mobileXL} {
      width: 97%;
    }
  }
`;

export const NameFieldsContainer = styled.div`
  .MuiFormControl-root {
    height: unset !important;
    width: 100%;
    max-width: 100%;
    margin: 0;
  }
  .Mui-error {
    width: 450px !important;
    margin-left: 0;
    @media ${DEVICES.mobileXL} {
      width: 100% !important;
    }
  }
`;

export const BeneIdentityHelperText = styled.div<{ $hasError?: boolean; $marginTop?: string }>`
  margin-top: ${(props) => props.$marginTop} !important;
  font-size: 14px;
  line-height: 22px;
  font-family: ${FONT_FAMILY.hellix.regular};
  color: ${COLORS.textGrey};
`;

export const WalletText = styled.p`
  font-size: 14px;
  font-family: ${FONT_FAMILY.hellix.regular};
  color: ${COLORS.textGrey};
`;
